const $ = jQuery

function SmoothScroll () {
  $(document).on('click', 'a[href*="#"]', function (event) {
    // Don't scroll if it's not on the same page
    if (
      location.pathname.replace(/^\//, '') !== this.pathname.replace(/^\//, '')
      || location.hostname !== this.hostname
    ) {
      return
    }

    event.preventDefault()

    const href = $(this).attr('href')
    const hash = href.substring(href.indexOf('#'))

    if (hash) {
      scroll(hash)
    }
  })
}

function scroll (element, speed = 800) {
  if ($(element).length === 0) {
    return
  }

  $('html, body').animate({
    scrollTop: $(element).offset().top - getHeaderHeight()
  }, speed)
}

function getHeaderHeight () {
  let height = 0
  height += window.innerWidth > 1536 ? 104 : 104
  const ADMIN_BAR = document.getElementById('wpadminbar')
  ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
  return height
}

module.exports = {
  SmoothScroll,
  scroll,
  getHeaderHeight
}
